import * as React from 'react';
import { useMemo } from 'react';
import { InterviewData } from '@/lib/interviewTypes';
import InterviewList from '@/components/interview/InterviewList';
import { sortInterviewsByDate } from '@/lib/interviewUtils';
import { Card, CardContent } from '@/components/ui/card';

interface AllScheduledInterviewsProps {
    interviews?: InterviewData[];
    batchName?: string;
    className?: string;
    isLoading?: boolean;
    error?: any;
    batchInfo?: {
        bCode?: string;
        _id?: string;
    };
}

const AllScheduledInterviews: React.FC<AllScheduledInterviewsProps> = ({ 
    interviews,
    batchName,
    className,
    isLoading,
    error,
    batchInfo
}) => {
    // Get all scheduled interviews and sort by date
    const scheduledInterviews = useMemo(() => {
        if (!interviews || interviews.length === 0) return [];

        // Show ALL interviews, sorted by scheduledDate (ascending)
        return sortInterviewsByDate([...interviews], false);
    }, [interviews]);

    // only upcoming interviews 
    // const scheduledInterviews = useMemo(() => {
    //     if (!interviews || interviews.length === 0) return [];
    //     const now = new Date();
    //     // Filter only scheduled interviews and only future dates, then sort by date
    //     return sortInterviewsByDate(
    //         interviews.filter(interview => interview.status === 'scheduled' && new Date(interview.scheduledDate) > now),
    //         false
    //     );
    // }, [interviews]);

    if (isLoading) {
        return (
            <Card className={className}>
                <CardContent className="pt-6">
                    <div className="animate-pulse space-y-3">
                        <div className="h-5 w-48 bg-gray-200 rounded" />
                        <div className="h-16 w-full bg-gray-100 rounded" />
                        <div className="h-16 w-full bg-gray-100 rounded" />
                    </div>
                </CardContent>
            </Card>
        );
    }

    return (
        <div className={className}>
            <InterviewList
                interviews={scheduledInterviews}
                title={batchName ? `Scheduled Interviews - ${batchName}` : 'All Scheduled Interviews'}
                showInstructor={true}
                error={error}
                batchInfo={batchInfo}
                emptyMessage="No scheduled interviews found. Schedule interviews to see them here."
            />
        </div>
    );
};

export default AllScheduledInterviews;

